import { put } from "redux-saga/effects";
import axiosGovernorate from "../../axios-governorate";
import * as actions from "../actions";
import { closeDialog, closeTooltip } from "../actions";

export function* purchaseToolsSaga({ upgradeId, params }: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "purchaseTool",
      upgradeId,
      ...params
    });

    const { data } = JSON.parse(response.data);

    const {
      hasFinishedQuest,
      availableQuests,
      finishedQuests,
      generals,
      general,
      resources,
      resourceBalances,
      development,
      slotChains,
      marketItems,
      extraMarketSlots,
      spells,
      spellsLimit,
      spellUpgradeAvailable,
      magicResearch,
      magicCore,
      magicClosed,
      readyToAttack,
      outlinePalace,
      armyEmperorTent,
      magicEmperorTent,
      thievesEmperorTent,
      credits,
      canSendCounterintelligence,
      limitingCrimes,
      crimeTypes,
      marketLimit
    } = data;

    if (params.govId) {
      yield put(actions.updateMember(params.govId, {
        spells,
        spellsLimit,
        spellUpgradeAvailable
      }));

      if (magicCore || magicCore === null) {
        yield put(actions.updateMember(params.govId, {
          magicCore,
          magicClosed
        }));
      }
    }

    if (!params.govId || params.isOwner) {
      if (slotChains) {
        yield put(actions.updateState({
          slotChains
        }));
      }

      if (generals) {
        yield put(actions.updateState({
          generals,
          readyToAttack
        }));
      }

      if (general) {
        yield put(actions.updateGeneral(
          general
        ));
      }

      if (resources) {
        yield put(actions.updateResources({
          resources,
          resourceBalances
        }));
      }

      if (development) {
        yield put(actions.updateState({
          development
        }));
      }

      if (marketLimit) {
        yield put(actions.updateState({
          marketLimit
        }));
      }

      if (marketItems) {
        yield put(actions.updateState({
          marketItems
        }));
      }

      if (extraMarketSlots) {
        yield put(actions.updateState({
          extraMarketSlots
        }));
      }

      if (spells) {
        yield put(actions.updateState({
          spells,
          spellsLimit,
          spellUpgradeAvailable
        }));
      }

      if (magicResearch) {
        yield put(actions.updateState({
          magicResearch
        }));
      }

      if (magicCore || magicCore === null) {
        yield put(actions.updateState({
          magicCore,
          magicClosed
        }));
      }

      if (outlinePalace) {
        yield put(actions.updateState({
          outlinePalace
        }));
      }

      if (armyEmperorTent) {
        yield put(actions.updateState({
          armyEmperorTent
        }));
      }

      if (magicEmperorTent) {
        yield put(actions.updateState({
          magicEmperorTent
        }));
      }

      if (thievesEmperorTent) {
        yield put(actions.updateState({
          thievesEmperorTent
        }));
      }

      if (canSendCounterintelligence !== undefined) {
        yield put(actions.updateState({
          canSendCounterintelligence,
          limitingCrimes,
          crimeTypes
        }));
      }

      if (hasFinishedQuest) {
        yield put(actions.updateState({
          hasFinishedQuest,
          availableQuests,
          finishedQuests
        }));
      }
    }

    yield put(actions.updateCredits(credits));
    yield put(closeTooltip());
    yield put(closeDialog());
  } catch (error) {
    console.log(error.message);
  }
}
